import type { EntityRegistryEntry } from '../types';

export const journalEntryConfig: EntityRegistryEntry = {
    fetchAttributes: ['Id', 'DisplayName', 'TargetType', 'Attribute', 'TargetId', 'Recorded', 'Source', 'Status'],
    tableFlags: {
        sortingDisabled: true,
        createDisabled: true,
        targetTypeFilter: true,
    },
    detailTabs: { hideJournalTab: true },
};
